import {
  alabasterSuede,
  asset1,
  asset2,
  asset3,
  asset4,
  asset5,
  asset6,
  asset7,
  asset8,
  blackSuede,
  cinderOrangeSuede,
} from './assets'

const assets: any = [
  {
    src: asset1,
    x: 0,
    y: 0,
    itemId: 101,
    majorLayer: true,
  },
  {
    src: asset8,
    x: 36.9837,
    y: 43.1103,
  },
  {
    src: asset7,
    x: 2,
    y: 236,
    itemId: 102,
    majorLayer: true,
  },
  {
    src: asset6,
    x: 146.0472,
    y: 272.8392,
    itemId: 103,
    majorLayer: true,
  },
  {
    src: asset5,
    x: -2.7729,
    y: 41.9985,
    itemId: 110,
  },
  {
    src: asset4,
    x: 515.853,
    y: 169.5954,
    itemId: 109,
  },

  {
    src: asset2,
    x: 17.25,
    y: 99.435,
    itemId: 108,
  },
  {
    src: asset3,
    x: 422.6163,
    y: 348.7041,
    itemId: 101,
  },
  { itemId: 114, x: 290, y: 390, fontSize: 30, angle: -6, majorLayer: true },
]

const data = {
  assets: assets,
  'black-suede': [{ src: blackSuede, x: 0, y: 0, zindex: 1 }],
  'cinder-orange-suede': [{ src: cinderOrangeSuede, x: 0, y: 0, zindex: 1 }],
  'alabaster-suede': [{ src: alabasterSuede, x: 0, y: 0, zindex: 1 }],
}

export default data
